import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeedPostFormComponent } from '@app/feed/feed-post-form/feed-post-form.component';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { EmptyComponent } from '@core/components/empty/empty.component';
import { PaginationModule } from '@core/components/pagination/pagination.module';

import { IconComponent } from '@shared/icon/icon.component';
import { SchoolFeedComponent } from './school-feed.component';

@NgModule({
  declarations: [SchoolFeedComponent],
  exports: [SchoolFeedComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,
    IconComponent,
    PaginationModule,
    RouterModule,

    EmptyComponent,
    ContentCardModule,
    FeedPostFormComponent,
  ],
})
export class SchoolFeedModule {}
